import { useQuery } from '@tanstack/react-query';
import { potsService, FetchPotsRequest, FetchPotsResponse } from '@aslanpay/portal-common-lib';

const useFetchPots = (params: FetchPotsRequest) => {
  return useQuery<FetchPotsResponse, Error>(['fetchPots', params], () =>
    potsService.fetchPots(params)
  );
};

export default useFetchPots;
